
export class ScrollToHotspot {
    constructor() {
        const hotspots: NodeListOf<HTMLElement> = document.querySelectorAll("[data-hotspot]") as NodeListOf<HTMLElement>;
        if (hotspots) {
            this.Initialize();
            this.CheckHash();
        }
    }   

    private Initialize(): void {
        const hotspotLinks: NodeListOf<HTMLElement> = document.querySelectorAll("[data-hotspot-link]") as NodeListOf<HTMLElement>;
        
        for (let i = 0; i < hotspotLinks.length; i++) {
            hotspotLinks[i].addEventListener("click", (e) => {
                e.preventDefault();
                const id: string = hotspotLinks[i].getAttribute("data-hotspot-link");
                const type: string = hotspotLinks[i].getAttribute("data-hotspot-link-type");
                if (type === "hash") {
                    this.ScrollTo(id);
                    window.location.hash = `#${id}`;
                }
            });
        }
    }  

    private ScrollTo(id: string): void {
        const hotspots: NodeListOf<HTMLElement> = document.querySelectorAll("[data-hotspot]") as NodeListOf<HTMLElement>;

        for (let j = 0; j < hotspots.length; j++) {
            const hotspot: string = hotspots[j].getAttribute("data-hotspot");
            if (id === hotspot) {
                hotspots[j].scrollIntoView();
                break;
            }
        }
    }  

    private CheckHash(): void {
        if (window.location.hash) {
            const hashValue: string = window.location.hash;
            this.ScrollTo(hashValue.replace("#", "");
        }
    }     
}



// WEBPACK FOOTER //
// ./src/global/ScrollToHotspot.ts